import React from "react";
import "./landing-page.styles.scss";
import Header from "../../components/Header/header.component";
import BottomSocialIcons from "../../components/Header/BottomSocialIcons/bottom-social-icons.component";

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="landing-container">
        <Header />
        <BottomSocialIcons />
      </div>
    );
  }
}

export default LandingPage;
